'use client';

import ThreeButtonsTopBar from '@/app/ui/common/three-buttons-top-bar';
import HomeBlack2424 from '@svg/common/home_black_24_24.svg';
import Link from 'next/link';
import { useRouter } from 'next/navigation';

const TopBarLeftButton = () => {
  const router = useRouter();

  return (
    <button
      className='w-24pxr h-24pxr flex items-center justify-center'
      onClick={() => {
        router.back();
      }}
    >
      <img src='https://front-cdn.zzimcar.com/images/back.svg' alt='back' />
    </button>
  );
};

const TopBarCenterTitle = () => {
  return <h3 className='text-new-gray-900 body-16-md'>커뮤니티</h3>;
};

const TopBarRightButton = () => {
  return (
    <Link href='/' scroll={true} prefetch={false} className='w-24pxr h-24pxr flex items-center justify-center'>
      <HomeBlack2424 />
    </Link>
  );
};

export default function SharingTripsListTopBar() {
  return (
    <ThreeButtonsTopBar
      leftButton={<TopBarLeftButton />}
      centerTitle={<TopBarCenterTitle />}
      rightButton={<TopBarRightButton />}
    />
  );
}
